// See: https://painttheweb.de/flood-component/canal-asset-module-gdpr

// Main Class
import Gdpr from './src/Gdpr';

export default Gdpr;
